// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"204":"2639e70d","325":"d5a5c51e","787":"1eb96842"}[chunkId] + ".chunk.js";
};